export type RoleType = "administrator" | "customer";

export enum RoleEnum {
  ADMINISTRATOR = "administrator",
  CUSTOMER = "customer",
}
